import { render, staticRenderFns } from "./POIConferenceRoomsFields.vue?vue&type=template&id=8fe1c5d6"
import script from "./POIConferenceRoomsFields.js?vue&type=script&lang=js&external"
export * from "./POIConferenceRoomsFields.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports